<template>
  <layout-public>
    <div class="card card-login">
      <form class="card-stacked" @submit.prevent="register">
        <div class="card-content grey lighten-4">
          <h3>Registrarse en el Sistema</h3>
        </div>
        <div class="card-content content-input">
          <div class="input-field">
            <input type="text" id="name" v-model="form.name" v-bind:class="{ invalid: errors.name }">
            <label for="name" id="label-name">Nombre</label>
            <span class="helper-text helper-text-error" v-for="(item, index) in errors.name" :key="index" data-success="right">* {{ item }}</span>
          </div>
          <div class="input-field">
            <input type="text" id="ci" v-model="form.ci" v-bind:class="{ invalid: errors.ci }">
            <label for="ci" id="label-ci">Cedula de Identidad</label>
            <span class="helper-text helper-text-error" v-for="(item, index) in errors.ci" :key="index" data-success="right">* {{ item }}</span>
          </div>
          <div class="input-field">
            <input type="email" id="email" v-model="form.email" v-bind:class="{ invalid: errors.email }">
            <label for="email" id="label-email">Correo Electrónico</label>
            <span class="helper-text helper-text-error" v-for="(item, index) in errors.email" :key="index" data-success="right">* {{ item }}</span>
          </div>
          <div class="input-field">
            <input type="password" id="password" v-model="form.password" v-bind:class="{ invalid: errors.password }">
            <label for="password" id="label-password">Clave</label>
            <span class="helper-text helper-text-error" v-for="(item, index) in errors.password" :key="index" data-success="right">* {{ item }}</span>
          </div>
          <div class="input-field">
            <input type="password" id="password-confirm" v-model="form.password_confirmation" v-bind:class="{ invalid: errors.password_confirmation }">
            <label for="password-confirm" id="label-password-confirm">Repetir Clave</label>
            <span class="helper-text helper-text-error" v-for="(item, index) in errors.password_confirmation" :key="index" data-success="right">* {{ item }}</span>
          </div>
        </div>
        <div class="card-action">
          <button
            class="btn waves-effect waves-light deep-orange darken-2"
            type="submit"
            name="action"
          >
            Registrarse
            <i class="material-icons right">send</i>
          </button>
          <router-link :to="{ name: 'login' }" class="btn-flat button-back"><i class="fas fa-arrow-left"></i> Volver</router-link>
        </div>
      </form>
    </div>
    <loader :show="loaderStatus"></loader>
  </layout-public>
</template>
<script>
import LayoutPublic from '@/components/layouts/Public'
import axios from 'axios'
import validate from 'validate.js'
import Loader from '@/components/Loader'
import * as M from 'materialize-css'

export default {
  data () {
    return {
      loaderStatus: false,
      form: {
        name: '',
        ci: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      errors: {
        name: false,
        ci: false,
        email: false,
        password: false,
        password_confirmation: false
      },
      error: null
    }
  },
  mounted () {
    document.title = 'Registro'
  },
  components: {
    LayoutPublic,
    Loader
  },
  methods: {
    register () {
      this.errors = {
        name: false,
        ci: false,
        email: false,
        password: false,
        password_confirmation: false
      }
      const constraints = this.getConstraints()
      const errors = validate(this.form, constraints, {fullMessages: false})
      if (errors) {
        this.errors = errors
        return
      }
      this.loaderStatus = true
      axios.post(process.env.ROOT_API + '/api/auth/register', this.form)
        .then(
          (response) => {
            this.loaderStatus = false
            this.$router.push('/dashboard')
            M.toast({html: '<span>Su <strong>registro</strong> fue completado con éxito, puede iniciar sessión</span>', classes: 'teal lighten-2'})
          }
        )
        .catch(
          (err) => {
            this.loaderStatus = false
            // err.response.data.message
            this.errors = err.response.data.errors
            // console.log(['hubo un error', err.response.data])
            M.toast({html: 'Ocurrio un error al guardar el formulario', classes: 'red'})
          }
        )
      // axios.interceptors.response.use(
      //   (response) => {
      //     this.loaderStatus = false
      //     console.log(response)
      //   },
      //   (error) => {
      //     this.loaderStatus = false
      //     console.log(error)
      //     return Promise.reject(error.response)
      //   }
      // )
    },
    getConstraints () {
      return {
        name: {
          presence: {
            message: 'Es requerido',
            allowEmpty: false
          }
        },
        ci: {
          presence: {
            message: 'Es requerido',
            allowEmpty: false
          },
          numericality: {
            onlyInteger: true,
            message: 'Solo puede ingresar numeros'
          },
          length: {
            minimum: 6,
            maximum: 8,
            message: function (value, attribute, validatorOptions, attributes, globalOptions) {
              return validate.format('Debe tener entre %{minimum} y %{maximum} digitos', {
                minimum: validatorOptions.minimum,
                maximum: validatorOptions.maximum
              })
            }
          }
        },
        email: {
          presence: {
            message: 'Es requerido',
            allowEmpty: false
          },
          email: {
            message: 'Debe ingresar un Correo electronico'
          }
        },
        password: {
          presence: {
            message: 'Es requerido',
            allowEmpty: false
          },
          length: {
            minimum: 6,
            message: 'Debe tener un minimo de 6 digitos'
          }
        },
        password_confirmation: {
          equality: {
            attribute: 'password',
            message: 'Las claves no coinciden'
          }
        }
      }
    }
  },
  computed: {
    authError () {
      return this.$store.getters.authError
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/auth/Register.vue